module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    on: {
      "touchend": _vm.handleTouchEnd
    }
  }, [(_vm.show) ? _c('dof-overlay', _vm._b({
    ref: "overlay",
    attrs: {
      "show": _vm.haveOverlay && _vm.isOverShow
    },
    on: {
      "dofOverlayBodyClicked": _vm.dofOverlayBodyClicking
    }
  }, 'dof-overlay', _vm.overlayCfg, false)) : _vm._e()], 1), (_vm.show) ? _c('div', {
    ref: "dof-confirm",
    class: ['dof-confirm', _vm.pos],
    style: _vm.padStyle,
    attrs: {
      "height": _vm._height,
      "hack": _vm.isNeedShow
    }
  }, [_vm._t("confirmContent"), (_vm.title) ? _c('text', {
    staticClass: ["confirm-title"]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    staticClass: ["confirm-content-wrapper"]
  }, [_c('text', {
    staticClass: ["confirm-content"]
  }, [_vm._v(_vm._s(_vm.content))])]), _c('div', {
    staticClass: ["confirm-buttons"]
  }, [_c('div', {
    staticClass: ["confirm-button-left"],
    on: {
      "click": _vm.leftBtnClick
    }
  }, [_c('text', {
    staticClass: ["left-button"]
  }, [_vm._v(_vm._s(_vm.leftBtnText))])]), _c('div', {
    staticClass: ["confirm-button-right"],
    on: {
      "click": _vm.rightBtnClick
    }
  }, [_c('text', {
    staticClass: ["right-button"]
  }, [_vm._v(_vm._s(_vm.rightBtnText))])])]), _c('div', {
    style: {
      height: _vm.isipx ? '68px' : '0px',
      'background-color': '#ffffff'
    }
  })], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-163fc8c6!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-confirm/index.vue
// module id = 581
// module chunks = 0 1